import { useExportablesModalContext } from "@/components/AIComponents/ExportablesModal/ExportablesModalContext/useExportablesModalContext";
import ArticlePreview from "@/components/ArticlePreview";
import {
  articlePreviewWrapperCss,
  contentWrapperCss,
  mediaWrapperCss,
  titleCss,
  titleWrapperCss,
} from "./ExportablesArticlePreview.styles";

const ExportablesArticlePreview = () => {
  const { content, contentMetadata, currentLevel } =
    useExportablesModalContext();

  return (
    <div css={articlePreviewWrapperCss}>
      <ArticlePreview
        content={content}
        currentLevel={currentLevel}
        contentMetadata={contentMetadata}
        styleOverrides={{
          title: titleCss,
          titleWrapper: titleWrapperCss,
          mediaWrapper: mediaWrapperCss,
          contentWrapper: contentWrapperCss,
        }}
      />
    </div>
  );
};

export default ExportablesArticlePreview;
